import React from "react";

function ConfirmationModal({
  isDeletingShipping,
  confirmDelete,
  confirmModal,
  cancelDelete,
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8 relative animate-fade-in">
        <div className="flex flex-col items-center text-center text-red-700">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={60}
            height={60}
            viewBox="0 0 512 512"
          >
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={32}
              d="M85.57 446.25h340.86a32 32 0 0 0 28.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0 0 28.17 47.17"
            ></path>
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={32}
              d="m250.26 195.39l5.74 122l5.73-121.95a5.74 5.74 0 0 0-5.79-6h0a5.74 5.74 0 0 0-5.68 5.95"
            ></path>
            <path
              fill="currentColor"
              d="M256 397.25a20 20 0 1 1 20-20a20 20 0 0 1-20 20"
            ></path>
          </svg>
          <h2 className="text-xl font-bold text-red-700 mb-2">
            Delete Shpping Option?
          </h2>
          <p className="text-gray-700 mb-4">
            Are you sure you want to{" "}
            <span className="font-bold text-red-600">permanently delete</span>{" "}
            the shipping option
            {confirmModal.shipping?.name && (
              <span className="font-semibold">
                {" "}
                "{confirmModal.shipping.name}"
              </span>
            )}
            ?<br />
            This action <span className="font-bold">cannot be undone</span>.
          </p>
          <div className="flex gap-4 w-full mt-2">
            <button
              onClick={confirmDelete}
              disabled={isDeletingShipping}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-md transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {isDeletingShipping ? "Deleting..." : "Delete"}
            </button>
            <button
              onClick={cancelDelete}
              disabled={isDeletingShipping}
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-md transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
